import { useNavigate } from '@tanstack/react-router';

import { ReferralsPage } from '@/features/referrals/ReferralsPage';

import { referralsRoute, wizardInitToCampaignsSearch } from './routes';

/**
 * Route adapter for /referrals (SCRUM-616). Reads the `scope` search param
 * (?scope=mine|all, SCRUM-329) into ReferralsPage's initialAssignedToMe, and
 * clears it after consumption via a replace-navigation (no history entry). The
 * onOpenWizard producer (SCRUM-327 console approve) navigates to the Campaigns
 * deep-link.
 */
export function ReferralsRoute() {
  const navigate = useNavigate();
  const search = referralsRoute.useSearch();
  const initialAssignedToMe = search.scope === 'mine';

  return (
    <ReferralsPage
      initialAssignedToMe={initialAssignedToMe}
      onScopeConsumed={() => {
        // Drop ?scope from the URL once applied so a later plain visit / refresh
        // does not re-scope. replace:true keeps it out of history.
        void navigate({ to: '/referrals', search: {}, replace: true });
      }}
      onOpenWizard={(init) => {
        void navigate({ to: '/campaigns', search: wizardInitToCampaignsSearch(init) });
      }}
    />
  );
}
